<template>
  <DialogWrapper
    close-on-cancel
    class="invite-open-question-dialog"
    saveBtnLabelI18nKey="common.btn.invite"
    :show.sync="show"
    :loading="loading"
    :titleI18nKey="`${i18nPrefix}.title`"
    @save="handleSave"
  >
    <div class="tip-message-container">
      <div class="tip">{{ $t(`${i18nPrefix}.message.inviteTip.0`) }}</div>
      <div class="tip">{{ $t(`${i18nPrefix}.message.inviteTip.1`) }}</div>
      <div class="tip">{{ $t(`${i18nPrefix}.message.knockoutTip`) }}</div>
    </div>
    <div class="question-container">
      <QuestionListEditor
        v-model="questionList"
        append-dialog-to-body
        new-dialog-style
        :group-list="groupList"
        :disabled-question-type="disabledQuestionType"
        :size-limit="questionSizeLimit"
        :disable-question-group="disableQuestionGroup"
        :hidden-question-template="hiddenQuestionTemplate"
      />
    </div>
  </DialogWrapper>
</template>

<script>
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import QuestionListEditor from '@/components/openQuestion/questionListEditor.vue'
import { mapActions } from 'vuex'
import { MAX_NORMAL_QUESTION_ATTACHMENT_TYPE_SIZE_LIMIT, MAX_NORMAL_QUESTION_VIDEO_TYPE_SIZE_LIMIT, QUESTION_TYPE } from '@/constant/openQuestion'
import _ from 'lodash'

export default {
  components: {
    DialogWrapper,
    QuestionListEditor
  },
  props: {
    jobId: {
      required: true
    },
    applicationList: {
      required: true
    },
    isAllApplication: {
      default: false
    },
    searchParams: {
      required: false
    },
    hiddenVideoQuestion: {
      default: true
    },
    hiddenAttachmentQuestion: {
      default: true
    },
    hiddenQuestionTemplate: {
      default: false
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.invitation.openQuestion',
      show: false,
      loading: false,
      groupListLoader: null,
      groupList: [],
      questionList: [],
      questionSizeLimit: {
        [QUESTION_TYPE.VIDEO]: MAX_NORMAL_QUESTION_VIDEO_TYPE_SIZE_LIMIT,
        [QUESTION_TYPE.ATTACHMENT]: MAX_NORMAL_QUESTION_ATTACHMENT_TYPE_SIZE_LIMIT
      },
      invitation: {}
    }
  },
  computed: {
    hasVideoQuestionPermission () {
      return this.hasAnyPermission('PREMIUM_UPLOAD_VIDEO')
    },
    hasAttachmentQuestionPermission () {
      return this.hasAnyPermission('PREMIUM_UPLOAD_PORTFOLIO')
    },
    disableQuestionGroup () {
      return !this.hasAnyPermission('PERM_JOB_QUESTION_TEMPLATE')
    },
    disabledQuestionType () {
      const disabled = [QUESTION_TYPE.SINGLE_SELECT, QUESTION_TYPE.MULTIPLE_SELECT]
      if (!this.hasVideoQuestionPermission && this.hiddenVideoQuestion) {
        disabled.push(QUESTION_TYPE.VIDEO)
      }
      if (!this.hasAttachmentQuestionPermission && this.hiddenAttachmentQuestion) {
        disabled.push(QUESTION_TYPE.ATTACHMENT)
      }
      return disabled
    }
  },
  created () {

  },
  methods: {
    ...mapActions('application', ['inviteOpenQuestion']),
    ...mapActions('openQuestion', ['getQuestionTemplateGroupList']),
    openDialog () {
      this.show = true
    },
    async loadGroupList () {
      if (this.disableQuestionGroup) {
        return this.groupList
      }
      this.loading = true
      if (!this.groupListLoader) {
        this.groupListLoader = this.getQuestionTemplateGroupList({ active_only: 1 }).then(resp => {
          this.groupList = resp
        })
      }
      await this.groupListLoader
      this.loading = false
      return this.groupList
    },
    async handleSave () {
      if (this.loading) {
        return
      }
      if (this.questionList.length < 1) {
        return
      }
      this.loading = true
      const resp = await this.inviteOpenQuestion({
        job_id: this.jobId,
        is_all_application: this.isAllApplication,
        search_params: this.searchParams,
        candidate_ids: _.map(this.applicationList, item => item.candidate.id),
        question_list: _.map(this.questionList, question => {
          return {
            id: question.id,
            group_id: question.group_id,
            type: question.type,
            title: question.title,
            duration: question.duration,
            options: question.options
          }
        })
      })
      if (resp) {
        if (resp.status === 'success') {
          const message = resp.message
          const successCount = message.success_count
          const failCount = message.fail_count
          this.$message.success(this.$t(`${this.i18nPrefix}.message.inviteSuccessInfo`, { successCount, failCount }))
          this.$emit('addInviteQuestion', this.questionList)
          this.$emit('success', resp)
          this.questionList = []
          this.show = false
        } else {
          this.$message.warning(resp.message)
        }
      }
      this.loading = false
    }
  },
  watch: {
    show () {
      if (this.show) {
        this.loadGroupList()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.invite-open-question-dialog {
  .tip-message-container {
    .tip {
      margin-top: 5px;
      word-break: break-word;
    }
  }
}
</style>
